export const getComboBoxInputListModalId = (parentCompId: string) =>
  `listModal_${parentCompId}`;
